import { useEffect, useMemo, useState } from "react";
import {
  DEFAULT_TRANSLATION_LANGUAGES,
  LocalStorageLanguageProperty,
} from "../entities/Language";
import { LocalStorageService } from "../services/LocalStorageService";
import { TranslationContext } from "./TranslationContext";
import { TranslationService } from "../services/TranslationService";
import { getTenantCredentials } from "../components/Tenant/selectors";
import { useSelector } from "react-redux";

export const TranslationProvider = ({ children, defaultTranslations }: any) => {
  const credentials = useSelector(getTenantCredentials);
  const languageFromLocalStorage = LocalStorageService.getItem(
    LocalStorageLanguageProperty.LANGUAGE,
  );

  let initialLanguage: string = DEFAULT_TRANSLATION_LANGUAGES.US;

  if (credentials?.country?.language?.shortName?.length) {
    initialLanguage = credentials?.country?.language?.shortName.toUpperCase();
  }
  if (languageFromLocalStorage) {
    initialLanguage = languageFromLocalStorage.toUpperCase();
  }
  const [translations, setTranslations] = useState<any>(defaultTranslations);
  const [contextLanguage, setContextLanguage] = useState<string>();

  const value = useMemo(
    () => ({
      translations,
      setTranslations,
      contextLanguage,
      setContextLanguage,
    }),
    [translations, contextLanguage],
  );

  useEffect(() => {
    setContextLanguage(initialLanguage);
  }, [initialLanguage]);

  useEffect(() => {
    if (contextLanguage) {
      TranslationService.getTranslations(contextLanguage)
        .then((response) => {
          setTranslations(response);
        })
        .catch(() => {});
    }
  }, [contextLanguage]);

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};
